<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <header class="card-header">
            <h4 class="pull-right">Изменить Единицу измерения</h4>
          </header>
          <div class="card-body">

            <form autcomplete="off" @submit.prevent="unitUpdate()">
            <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Язык</label>
                    <select class="form-control" @change="onSelectCategoryLang()" v-model="unitEdit.language">
                    <option disabled>Выберите тип</option>
                    <option v-for="language in languages" :value="language.lang" :key="language.id">
                      {{ language.lang }}
                    </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>Заголовок</label>
                    <input type="text" class="form-control" v-model="unit.title" autofocus />
                  </div>
                  <div class="form-group">
                    <label>Код</label>
                    <input type="text" class="form-control" v-model="unit.code" />
                  </div>
                  <div class="form-group">
                    <label>Код ОКЕИ</label>
                    <input type="text" class="form-control" v-model="unit.okei_id" />
                  </div>
                  <div class="form-group">
                    <label>Загаловок единст число</label>
                    <input type="text" class="form-control" v-model="unit.titleSingular" />
                  </div>
                  <div class="form-group">
                    <label>Загаловок множ число</label>
                    <input type="text" class="form-control" v-model="unit.titlePlural" />
                  </div>
                  <button type="submit" class="btn btn-primary">Изменить</button>
                </div>
            </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { GET, POST } from "@/shared/api";
export default {
  data() {
    return {
      unit: {},
      units: [],
      languages: [],
      showUnitEditModal: false,
    };
  },
  methods: {
    getUnit(id) {
      GET([], "/unit/" + id, this, false).then(response => {
        this.unit = response;
      });
    },
    getLanguages() {
      GET([], "/language", this, false).then(response => {
          this.languages = response;
      });
    },
    unitUpdate() {
      POST(this.unit, "/unitUpdate", this).then(response => {
        this.$router.push({ name: "unit" });
      });
    },
  },
  created() {
    this.getUnit(this.$route.params.unit_id);
    this.getLanguages()
  }
};
</script>
